import { ElementType } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '$components'

export type BreadcrumbItem = {
  path: string
  label: string
  icon?: ElementType
}

export type BreadcrumbProps = {
  items: BreadcrumbItem[]
  className?: string
}

export function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <div className={cn('flex items-center gap-stack-tight text-body-sm text-fg-subtle', className)}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1

        return (
          <div
            key={index}
            className="flex items-center"
          >
            {index > 0 && (
              <span className="mr-stack-tight mt-stack-dense text-fg-disabled">
                /
              </span>
            )
            }

            { isLast
              ? (
                <span className="text-fg font-medium flex items-center">
                  { item.icon && <item.icon className="size-4 mr-stack-dense" /> }
                  { item.label }
                </span>
              )
              : (
                <Link
                  to={item.path}
                  className="hover:text-fg-muted transition-colors flex items-center"
                >
                  { item.icon && <item.icon className="size-4 mr-stack-dense" /> }
                  { item.label }
                </Link>
              )
            }
          </div>
        )
      })}
    </div>
  )
}
